import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";
import { AccessRestrictions } from "@planzone/dto";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  accessRestrictions: AccessRestrictions;
  retrieveAccessRestrictions(
    request: Boundaries["retrieveAccessRestrictions"]["request"],
  ): void;
}

function useRetrieveAccessRestrictions(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveAccessRestrictionsRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveAccessRestrictionsRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveAccessRestrictionsRequestFailure,
    ),
    accessRestrictions: useSelector(selector.getAccessRestrictions),
    retrieveAccessRestrictions: core.retrieveAccessRestrictions,
  };
}

export { useRetrieveAccessRestrictions };
